import Content from 'components/common/Content-v2';
import MainTitle from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import AddQuoteForm from 'components/forms/quotes/add';
const AddMember = props => {
	return (
		<>
			<MainTitle>
				<h1>Añadir cotización</h1>
				<LinkButton to="/admin/quotes"> Regresar </LinkButton>
			</MainTitle>
			<Content>
				<AddQuoteForm />
			</Content>
		</>
	);
};
export default AddMember;
